import PropTypes from 'prop-types';

import { useEmailCampaignDetailsContext } from '../../../../contexts/EmailCampaignDetailsContext';
import { useEmailReviewActions } from '../hooks/useEmailReviewActions';

import EmailContactsList from './EmailContactsList';
import EmailPreviewPane from './EmailPreviewPane';

const EmailReviewSplitScreen = ({
	campaignId,
	emails,
	selectedEmailId,
	setSelectedEmailId,
	selectedEmail,
	refetchEmails,
	signatureContent,
	emailAccountId,
	fetchNextPage,
	hasNextPage,
	isFetchingNextPage,
}) => {
	const { campaign } = useEmailCampaignDetailsContext();
	const { handleApprove, handleUnapprove, handleUpdate, handleRegenerate, isRegenerating, isUnapproving } =
		useEmailReviewActions(campaignId, {
			emails,
			setSelectedEmailId,
			refetchEmails,
		});

	return (
		<div className="grid grid-cols-12 gap-4" style={{ height: 'calc(100vh - 400px)', minHeight: '500px' }}>
			{/* Left: Contact List */}
			<div className="col-span-5 h-full">
				<EmailContactsList
					emails={emails}
					selectedEmailId={selectedEmailId}
					onSelectEmail={setSelectedEmailId}
					fetchNextPage={fetchNextPage}
					hasNextPage={hasNextPage}
					isFetchingNextPage={isFetchingNextPage}
				/>
			</div>

			{/* Right: Email Preview */}
			<div className="col-span-7">
				<EmailPreviewPane
					email={selectedEmail}
					onApprove={handleApprove}
					onUnapprove={handleUnapprove}
					onUpdate={handleUpdate}
					onRegenerate={handleRegenerate}
					isRegenerating={isRegenerating}
					isUnapproving={isUnapproving}
					campaignStatus={campaign?.campaignStatus}
					signatureContent={signatureContent}
					campaignId={campaignId}
					emailAccountId={emailAccountId}
				/>
			</div>
		</div>
	);
};

EmailReviewSplitScreen.propTypes = {
	campaignId: PropTypes.string.isRequired,
	emails: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
		}),
	).isRequired,
	selectedEmailId: PropTypes.string,
	setSelectedEmailId: PropTypes.func.isRequired,
	selectedEmail: PropTypes.object,
	refetchEmails: PropTypes.func.isRequired,
	signatureContent: PropTypes.string,
	emailAccountId: PropTypes.string,
	fetchNextPage: PropTypes.func.isRequired,
	hasNextPage: PropTypes.bool,
	isFetchingNextPage: PropTypes.bool,
};

export default EmailReviewSplitScreen;
